module.exports = __webpack_public_path__ + "img/mp-boards-final.cecc2da9.jpg";